import * as Dtos from "../dtos/Tmd.dtos";

export const
    LoadProjectInvestigatorById: IProjectInvestigatorLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_PROJECTINVESTIGATOR_LOAD_BY_ID,
            id
        }
    },
    LoadProjectInvestigatorsByProjectId: IProjectInvestigatorsLoadByProjectIdActionCreator = (projectId) => {
        return {
            type: ACTION_PROJECTINVESTIGATORS_LOAD_BY_PROJECTID,
            projectId
        }
    },
    LoadSuccess: IProjectInvestigatorLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_PROJECTINVESTIGATOR_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IProjectInvestigatorLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTINVESTIGATOR_LOAD_FAILURE,
            responseStatus
        }
    },

    CreateProjectInvestigator: IProjectInvestigatorCreateActionCreator = (personnelId, trialId) => {

        return {
            type: ACTION_PROJECTINVESTIGATOR_CREATE,
            personnelId, 
            trialId
        }
    },
    CreateSuccess: IProjectInvestigatorCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_PROJECTINVESTIGATOR_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IProjectInvestigatorCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTINVESTIGATOR_CREATE_FAILURE,
            responseStatus
        }
    },

    SaveProjectInvestigator: IProjectInvestigatorSaveActionCreator = (formData) => {
        return {
            type: ACTION_PROJECTINVESTIGATOR_SAVE,
            formData
        }
    },
    SaveSuccess: IProjectInvestigatorSaveSuccessActionCreator = (formData, formState, lookups, responseStatus) => {
        return {
            type: ACTION_PROJECTINVESTIGATOR_SAVE_SUCCESS,
            formData,
            formState,
            lookups,
            responseStatus
        }
    },
    SaveFailure: IProjectInvestigatorSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTINVESTIGATOR_SAVE_FAILURE,
            responseStatus
        }
    },
    
    ValidateProjectInvestigator: IProjectInvestigatorValidateActionCreator = (formData) => {
        return {
            type: ACTION_PROJECTINVESTIGATOR_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IProjectInvestigatorValidateSuccessActionCreator = (formData, formState, lookups, responseStatus) => {
        return {
            type: ACTION_PROJECTINVESTIGATOR_VALIDATE_SUCCESS,
            formData,
            formState,
            lookups,
            responseStatus
        }
    },
    ValidateFailure: IProjectInvestigatorValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTINVESTIGATOR_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IProjectInvestigatorClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_PROJECTINVESTIGATOR_CLEAR,
            propertiesToClear
        }
    };



export const
    ACTION_PROJECTINVESTIGATOR_LOAD_BY_ID = "ACTION_PROJECTINVESTIGATOR_LOAD_BY_ID",
    ACTION_PROJECTINVESTIGATORS_LOAD_BY_PROJECTID = "ACTION_PROJECTINVESTIGATORS_LOAD_BY_PROJECTID",
    ACTION_PROJECTINVESTIGATOR_LOAD_SUCCESS = "ACTION_PROJECTINVESTIGATOR_LOAD_SUCCESS",
    ACTION_PROJECTINVESTIGATOR_LOAD_FAILURE = "ACTION_PROJECTINVESTIGATOR_LOAD_FAILURE",
    
    ACTION_PROJECTINVESTIGATOR_CREATE = "ACTION_PROJECTINVESTIGATOR_CREATE",
    ACTION_PROJECTINVESTIGATOR_CREATE_SUCCESS = "ACTION_PROJECTINVESTIGATOR_CREATE_SUCCESS",
    ACTION_PROJECTINVESTIGATOR_CREATE_FAILURE = "ACTION_PROJECTINVESTIGATOR_CREATE_FAILURE",

    ACTION_PROJECTINVESTIGATOR_SAVE = "ACTION_PROJECTINVESTIGATOR_SAVE",
    ACTION_PROJECTINVESTIGATOR_SAVE_SUCCESS = "ACTION_PROJECTINVESTIGATOR_SAVE_SUCCESS",
    ACTION_PROJECTINVESTIGATOR_SAVE_FAILURE = "ACTION_PROJECTINVESTIGATOR_SAVE_FAILURE",

    ACTION_PROJECTINVESTIGATOR_VALIDATE = "ACTION_PROJECTINVESTIGATOR_VALIDATE",
    ACTION_PROJECTINVESTIGATOR_VALIDATE_SUCCESS = "ACTION_PROJECTINVESTIGATOR_VALIDATE_SUCCESS",
    ACTION_PROJECTINVESTIGATOR_VALIDATE_FAILURE = "ACTION_PROJECTINVESTIGATOR_VALIDATE_FAILURE",

    ACTION_PROJECTINVESTIGATOR_CLEAR = "ACTION_PROJECTINVESTIGATOR_CLEAR";


export interface IProjectInvestigatorLoadSuccessAction {
    type: "ACTION_PROJECTINVESTIGATOR_LOAD_SUCCESS";
    formData: Dtos.ProjectInvestigator | Dtos.ProjectInvestigator[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectInvestigatorLoadSuccessActionCreator {
    (
        formData: Dtos.ProjectInvestigator | Dtos.ProjectInvestigator[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IProjectInvestigatorLoadSuccessAction;
}

export interface IProjectInvestigatorLoadFailureAction {
    type: "ACTION_PROJECTINVESTIGATOR_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectInvestigatorLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectInvestigatorLoadFailureAction;
}

export interface IProjectInvestigatorLoadByIdAction {
    type: "ACTION_PROJECTINVESTIGATOR_LOAD_BY_ID";
    id: number;
}

export interface IProjectInvestigatorLoadByIdActionCreator {
    (id: number): IProjectInvestigatorLoadByIdAction;
}

export interface IProjectInvestigatorsLoadByProjectIdAction {
    type: "ACTION_PROJECTINVESTIGATORS_LOAD_BY_PROJECTID";
    projectId: number;
}

export interface IProjectInvestigatorsLoadByProjectIdActionCreator {
    (projectId: number): IProjectInvestigatorsLoadByProjectIdAction;
}

export interface IProjectInvestigatorCreateAction {
    type: "ACTION_PROJECTINVESTIGATOR_CREATE";
    personnelId: number;
    trialId: number;
}

export interface IProjectInvestigatorCreateActionCreator {
    (
        personnelId: number,
        trialId: number
    ): IProjectInvestigatorCreateAction
}

export interface IProjectInvestigatorCreateSuccessAction {
    type: "ACTION_PROJECTINVESTIGATOR_CREATE_SUCCESS";
    formData: Dtos.ProjectInvestigator;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface IProjectInvestigatorCreateSuccessActionCreator {
    (
        formData: Dtos.ProjectInvestigator,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IProjectInvestigatorCreateSuccessAction;
}

export interface IProjectInvestigatorCreateFailureAction {
    type: "ACTION_PROJECTINVESTIGATOR_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectInvestigatorCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectInvestigatorCreateFailureAction;
}


export interface IProjectInvestigatorSaveAction {
    type: "ACTION_PROJECTINVESTIGATOR_SAVE";
    formData: Dtos.ProjectInvestigator;

}

export interface IProjectInvestigatorSaveActionCreator {
    (
        formData: Dtos.ProjectInvestigator,
    ): IProjectInvestigatorSaveAction;
}

export interface IProjectInvestigatorSaveSuccessAction {
    type: "ACTION_PROJECTINVESTIGATOR_SAVE_SUCCESS";
    formData: Dtos.ProjectInvestigator;
    formState: Dtos.FormState,
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectInvestigatorSaveSuccessActionCreator {
    (
        formData: Dtos.ProjectInvestigator,
        formState: Dtos.FormState,
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IProjectInvestigatorSaveSuccessAction;
}

export interface IProjectInvestigatorSaveFailureAction {
    type: "ACTION_PROJECTINVESTIGATOR_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectInvestigatorSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectInvestigatorSaveFailureAction;
}

export interface IProjectInvestigatorValidateAction {
    type: "ACTION_PROJECTINVESTIGATOR_VALIDATE";
    formData: Dtos.ProjectInvestigator;

}

export interface IProjectInvestigatorValidateActionCreator {
    (
        formData: Dtos.ProjectInvestigator,
    ): IProjectInvestigatorValidateAction;
}

export interface IProjectInvestigatorValidateSuccessAction {
    type: "ACTION_PROJECTINVESTIGATOR_VALIDATE_SUCCESS";
    formData: Dtos.ProjectInvestigator;
    formState: Dtos.FormState,
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectInvestigatorValidateSuccessActionCreator {
    (
        formData: Dtos.ProjectInvestigator,
        formState: Dtos.FormState,
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IProjectInvestigatorValidateSuccessAction;
}

export interface IProjectInvestigatorValidateFailureAction {
    type: "ACTION_PROJECTINVESTIGATOR_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectInvestigatorValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectInvestigatorValidateFailureAction;
}

export interface IProjectInvestigatorClearAction {
    type: "ACTION_PROJECTINVESTIGATOR_CLEAR";
    propertiesToClear?: string[];
}

export interface IProjectInvestigatorClearActionCreator {
    (propertiesToClear?: string[]): IProjectInvestigatorClearAction;
}

export type ProjectInvestigatorAction =
    IProjectInvestigatorLoadByIdAction |
    IProjectInvestigatorsLoadByProjectIdAction |
    IProjectInvestigatorLoadFailureAction |
    IProjectInvestigatorLoadSuccessAction |
    IProjectInvestigatorCreateAction |
    IProjectInvestigatorCreateSuccessAction |
    IProjectInvestigatorCreateFailureAction |
    IProjectInvestigatorClearAction |
    IProjectInvestigatorSaveAction |
    IProjectInvestigatorSaveSuccessAction |
    IProjectInvestigatorSaveFailureAction |
    IProjectInvestigatorValidateAction |
    IProjectInvestigatorValidateSuccessAction |
    IProjectInvestigatorValidateFailureAction;
